'use strict';
Object.defineProperty(exports, '__esModule', { value: !0 }), exports.default = void 0;
var _dec, _dec2, _dec3, _class, _events = _interopRequireDefault(require('./events')), _index = require('./native/index'), _index2 = _interopRequireDefault(require('./web/index'));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : { default: e };
}
function _classCallCheck(e, t) {
    if (!(e instanceof t))
        throw new TypeError('Cannot call a class as a function');
}
function _toConsumableArray(e) {
    return _arrayWithoutHoles(e) || _iterableToArray(e) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError('Invalid attempt to spread non-iterable instance');
}
function _iterableToArray(e) {
    if (Symbol.iterator in Object(e) || '[object Arguments]' === Object.prototype.toString.call(e))
        return Array.from(e);
}
function _arrayWithoutHoles(e) {
    if (Array.isArray(e)) {
        for (var t = 0, n = new Array(e.length); t < e.length; t++)
            n[t] = e[t];
        return n;
    }
}
var IS_IN_APP = 'undefined' != typeof grounds, externalCallHandler = function r(e) {
        var a = e.name, t = e.fullName, o = e.args;
        return _index2.default[a] ? _index2.default[a].apply(_index2.default, _toConsumableArray(o)) : (console.warn('在外部环境调用了客户端方法\uFF1A'.concat(t || a, '()')), new Proxy({}, {
            get: function (e, t, n) {
                return r.bind(null, {
                    name: t,
                    fullName: ''.concat(a, '().').concat(t),
                    args: o
                });
            }
        }));
    }, addMethods = function (a) {
        return function (e) {
            Object.keys(a).forEach(function (r) {
                e.prototype[r] = function () {
                    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
                        t[n] = arguments[n];
                    return IS_IN_APP ? a[r].apply(a, t) : externalCallHandler({
                        name: r,
                        args: t
                    });
                };
            });
        };
    }, Grounds = (_dec = addMethods(_index.report))(_class = (_dec2 = addMethods(_index.baseInfo))(_class = (_dec3 = addMethods(_index.interactive))(_class = function e() {
        var t = this;
        _classCallCheck(this, e), this.on('exit', function () {
            console.log('exit'), t.trigger('exit');
        }), this.on('active', function () {
            console.log('active'), t.trigger('active');
        });
    }) || _class) || _class) || _class;
_events.default.mixTo(Grounds);
var _default = new Grounds();
exports.default = _default;